import { debtConsolidationFeaturesResponseSchema } from '@/api/debtConsolidation/schemas';
import { apiRequest } from '@/api/utils/api';

export const getFeatures = () =>
  apiRequest({
    url: '/debt-consolidation/features-steps',
    method: 'GET',
    schema: debtConsolidationFeaturesResponseSchema,
  });
